import { render, staticRenderFns } from "./receiverList.vue?vue&type=template&id=44549c96&"
import script from "./receiverList.vue?vue&type=script&lang=js&"
export * from "./receiverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports